let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ofKC")).then(() => parcelRequire('3Cs0V'));